import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import {
  getFingerprint,
  getIamAccessToken,
  getSessionId,
} from '@/api/authSession'

/** Same env chain as auth.service — IAM / Auth Utils base (api-dev-iam). */
export function getIamBaseUrl(): string {
  return (
    import.meta.env.VITE_AUTH_UTILS_BASE_URL ||
    import.meta.env.VITE_IAM_API_URL ||
    import.meta.env.VITE_AUTH_UTILS_URL ||
    'https://api-dev-iam.leap-india.com'
  )
}

/**
 * Axios instance for IAM only (`/api/v1/auth/*`).
 * Attaches X-XSRF-Token, Authorization Bearer, optional X-Session-Id on every request when present
 * (required by IAM authenticate middleware after verify-otp).
 */
export const iamClient = axios.create({
  baseURL: getIamBaseUrl(),
  withCredentials: true,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

iamClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const fp = getFingerprint()
    if (fp) config.headers['X-XSRF-Token'] = fp

    const jwt = getIamAccessToken()
    if (jwt) config.headers.Authorization = `Bearer ${jwt}`

    const sid = getSessionId()
    if (sid) config.headers['X-Session-Id'] = sid

    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      const h = config.headers as Record<string, unknown> & { delete?: (name: string) => void }
      if (typeof h.delete === 'function') {
        h.delete('Content-Type')
      } else {
        delete h['Content-Type']
        delete h['content-type']
      }
    }
    return config
  },
  (error: AxiosError) => Promise.reject(error)
)

export default iamClient
